<template>
  <div class="grid-view tab-bill-payment">
    <query-bill-payment
      ref="queryBillPayment"
      identify="queryBillPayment"
      :view-source="pageSource"
      :show-real-clearing-state="searchConditions.showRealClearingState"
      :state="searchConditionsState"
      :paid-off="searchConditionsPaidOff"
      :is-check-charge="searchConditions.isCheckCharge"
      :show-controlled-charge="searchConditions.showControlledCharge"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :clearing-states="searchConditionsClearingStates"
      :show-wht="showWht"
      config-module="508"
      grid-config-module="190801"
      @rowDoubleClicked="rowDoubleClicked"
    >
      <div slot="operations">
        <el-button v-if="pageSource!=='financeAp'" no="1" type="primary" @click="toDetail(false, null)">{{ $t('Payment.viewDetails_SR') }}</el-button>
        <el-button v-show="[0, 1, 2, 3, 4, 5].includes(applicationStatus)" no="2" type="primary" @click="toCollectInvoice">{{ $t('Payment.collectInvoice') }}</el-button>
        <!-- <el-button v-if="pageSource!=='financeAp'" no="3" type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
        <el-dropdown
          v-if="pageSource!=='financeAp'"
          no="3"
          split-button
          type="primary"
          style="margin: 0 5px;"
          @click="toPrint($t('Payment.print'))"
          @command="toPrint"
        >
          {{ $t('Payment.print') }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-show="[0, 1, 2, 3, 4, 5].includes(applicationStatus)" no="4" type="primary" @click="toCreatePayment">{{ $t('Payment.newPaymentRequest') }}</el-button>
        <el-button v-show="[0].includes(applicationStatus)" no="5" type="primary" @click="doCommit">{{ $t('Payment.submit') }}</el-button>
        <el-button v-show="[0, 4].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuth_btnBillDelete'])" no="6" type="danger" @click="doDelete">{{ $t('Payment.delete') }}</el-button>
        <el-button v-show="[1].includes(applicationStatus) && this.hasBusinessVerify" no="7" type="primary" @click="doBusinessApproval">{{ isItACommercialAudit ? $t('Payment.officeApproval') : $t('Payment.businessApproval') }}</el-button>
        <el-button v-show="[1].includes(applicationStatus) && this.isDepartmentPermit" no="8" type="primary" @click="doDepartmentApproval">{{ $t('Payment.departmentApproval') }}</el-button>
        <el-button v-show="[2].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuth_financeVerify'])" no="9" type="primary" @click="doFinancialApproval">{{ $t('Payment.financialApproval') }}</el-button>
        <el-button v-show="([1].includes(applicationStatus) && this.hasBackPrivilege) || ([2, 3].includes(applicationStatus) && this.hasFinanceVerify)" no="10" type="primary" @click="doBack">{{ $t('Payment.return') }}</el-button>
        <el-button v-show="[1].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuth_financeVerify'])" no="11" type="primary" @click="doFinancialAudit">{{ $t('Payment.financialAudit') }}</el-button>
        <el-button v-show="[7].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuth_sendWeaver'])" no="12" type="primary" :disabled="canSendWeaver" @click="commitBillPayment">{{ $t('Payment.sendWeaver_SR') }}</el-button>
      </div>
      <template v-slot:other>
        <el-form :inline="true" label-width="60px" label-position="left" style="margin-right: 15px;">
          <el-form-item :label="$t('Billing.billingJob_billPaymentDate')" class="el-form-item-search">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateStart"
                    no="13"
                    type="date"
                    style="margin-right: 0px;"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  /></el-form-item>
              </el-col>
              <el-col :span="2"><span>{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateEnd"
                    no="14"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-checkbox v-model="allowTwoYearOutside" no="15">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </template>
    </query-bill-payment>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="billPaymentList"
      :location="location"
      @reloadData="reloadData"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialogJc'
import makeInvoiceStepOneDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepOneDialog'
import queryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPayment'
import moment from 'moment'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import { updateBillPaymentState, batchDelBillPayment, sendLtsBillPaymentFunc, SendWeaverJinchang } from '@/api/clearing/billPayment'
import { cache, cacheName } from '@/utils/cacheManager'
import { getUserInfo } from '@/utils/auth'
import billPaymentCreatorDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentCreatorDialog'
import { validateRoleByUserIdAndRoleName } from '@/api/role'
import GlobalDialog from '@/utils/GlobalDialog'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabBillPaymentJc',
  components: {
    CargoDialog,
    cargoTemplateSelectorDialog,
    billPaymentDialog,
    makeInvoiceStepOneDialog,
    queryBillPayment, // 付款申请查询列表
    makeInvoiceDialog, // 开票弹出框
    billPaymentCreatorDialog // 创建付款申请弹窗
  },
  props: {
    applicationStatus: { type: Number, default: 0 }, // 付款申请状态: 0=未提交;1=待业务审批;2=待财务审批;3=审批通过;4=未付清;5=全部;7=待发送云平台;8=云平台审批中;9=云平台审批通过;
    pageSource: { type: String, default: 'billPaymentList' },
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      openSapConfig: false,
      isItACommercialAudit: false,
      loading: false,
      searchConditions: {
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: '',
        showControlledCharge: false,
        isCheckCharge: true,
        showRealClearingState: true
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      hasBusinessVerify: false, // 是否有业务审批权限
      isDepartmentPermit: false, // 部门审批
      hasBackPrivilege: false, // 是否有退回权限
      hasFinanceVerify: false, // 财务审核权限
      isDirectPayment: false,
      isPaymentApplyFinancialAudit: false, // 待业务审核页面可以直接财务审核
      allowTwoYearOutside: false,
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      billPaymentDialog: { // 付款申请弹窗【查看明细】
        visible: false,
        title: '',
        billPaymentUuid: ''
      },
      makeInvoiceDialog: { // 收票弹窗页
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 5 // 开票方式: 5=付款申请
      },
      billPaymentCreatorDialog: null,
      canSendWeaver: false,
      location: LOG_BILL_PAYMENT.code
    }
  },
  computed: {
    searchConditionsState() {
      switch (this.applicationStatus) {
        case 0: return [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code]
        case 1: return [ClearingConstants.BILL_PAYMENT_COMMITED.code, ClearingConstants.BILL_PAYMENT_DEP_APROVED.code]
        case 2: return [ClearingConstants.BILL_PAYMENT_BIZ_APPROVED.code]
        case 3: return [ClearingConstants.BILL_PAYMENT_FINANCE_APPROVED.code]
        case 4:
        case 5: return []
        case 7: return [ClearingConstants.BILL_PAYMENT_FINANCE_APPROVED.code]
        case 8: return [ClearingConstants.BILL_PAYMENT_WEAVER_APPROVING.code]
        case 9: return [ClearingConstants.BILL_PAYMENT_WEAVER_APPROVED.code]
        default: return []
      }
    },
    searchConditionsClearingStates() {
      if (this.applicationStatus === 4) {
        return [0, 1]
      } else {
        return []
      }
    },
    searchConditionsPaidOff() {
      if (this.applicationStatus === 4) {
        return 0
      } else {
        return -1
      }
    },
    currentOffice() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Billing.billingJob_unlockBillPaymentDateQuery'), this.$t('Message.Prompt'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    currentOffice() {
      this.initConfig()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {
    async initConfig() {
      this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
      this.isItACommercialAudit = Number(cache.config.get('IsItACommercialAudit')) === 1
      let shae = false // 上海空运出口, 类似于 Department permit
      let isDirectPayment = false
      const roleMap = await validateRoleByUserIdAndRoleName(['上海空运付款', '付款申请直达']).then(res => {
        return res.data
      })
      if (roleMap) {
        if (roleMap.hasOwnProperty('上海空运付款') && roleMap['上海空运付款']) {
          shae = true
        }
        if (roleMap.hasOwnProperty('付款申请直达') && roleMap['付款申请直达']) {
          shae = true
          isDirectPayment = true
        }
      }
      this.isDirectPayment = isDirectPayment
      const billPaymentDepartmentPermit = Number(cache.config.get('BillPaymentDepartmentPermit'))
      if (billPaymentDepartmentPermit >= 1 || shae) {
        this.isDepartmentPermit = true
      } else {
        this.isDepartmentPermit = false
      }
      const paymentApplyFinancialAudit = Number(cache.config.get('PaymentApplyFinancialAudit'))
      if (paymentApplyFinancialAudit >= 1) {
        this.isPaymentApplyFinancialAudit = true
      } else {
        this.isPaymentApplyFinancialAudit = false
      }
      this.hasBusinessVerify = this.$checkPermission(['button_ACPayAuth_business'])
      const pd = this.$checkPermission(['button_ACPayAuth_department'])
      const p = this.$checkPermission(['button_ACPayAuth_business']) || getUserInfo().admin
      if (this.isDepartmentPermit) {
        this.hasBackPrivilege = pd || p
      } else {
        this.hasBackPrivilege = p
      }
      this.hasFinanceVerify = this.$checkPermission(['button_ACPayAuth_financeVerify'])
    },
    selectedData() {
      return this.$refs.queryBillPayment.getSelections()
    },
    // 是否可选择两年以外的时间点
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 查看详情
    toDetail(doubleClick = false, row = null) {
      let billPayment = null
      if (doubleClick) { // 双击查看
        billPayment = row
      } else {
        const chooseRows = this.$refs.queryBillPayment.getSelections()
        if (chooseRows && chooseRows.length > 0) {
          billPayment = chooseRows[0]
        }
      }
      if (!billPayment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      if (billPayment.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(billPayment.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      this.billPaymentDialog.billPaymentUuid = billPayment.uuid
      this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      const propsData = {
        visible: true,
        title: this.billPaymentDialog.title,
        billPaymentUuid: this.billPaymentDialog.billPaymentUuid,
        isDirectPayment: this.isDirectPayment,
        openSapConfig: this.openSapConfig,
        toExoSystemYGSH: String(cache.config.get('ToExoSystem')) === 'YGSH',
        step: 'step2',
        mode: 'edit',
        location: this.location
      }
      this.billPaymentDialog.dialog = new GlobalDialog(billPaymentDialog, { propsData })
      const { instance } = this.billPaymentDialog.dialog
      instance.$on('reloadData', this.reloadData)
      instance.$on('saveSuccess', this.saveBillPaymentSuccess)
    },
    // 收票按钮触发事件
    toCollectInvoice() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const queryOfficeId = this.$refs.queryBillPayment.queryOfficeId
      if (queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      let message = ''
      // 选中数据中是否存在可开票账单
      let isC = false
      for (const bp of chooseRows) {
        if (!bp.notInvoiceByCharge) {
          if (message) {
            message += ','
          }
          message = message + bp.billPaymentNo
        } else {
          isC = true
        }
      }
      if (message && isC) {
        this.$message.warning('包含已开票的费用，请重新选择！付款申请单号：' + message)
        return
      } else if (message && !isC) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      this.makeInvoiceDialog.isAr = false
      this.makeInvoiceDialog.isHedge = false
      this.makeInvoiceDialog.isSkipInvoiceFrom = false
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      this.makeInvoiceDialog.keys = keys
      this.makeInvoiceDialog.step = 'step1'
      this.$refs.invoice.makeInvoice({ ...this.makeInvoiceDialog })
    },
    // 创建付款申请
    toCreatePayment() {
      const propsData = {
        location: this.location,
        viewSource: 'JC'
      }
      this.billPaymentCreatorDialog = new GlobalDialog(billPaymentCreatorDialog, { propsData })
      const { instance } = this.billPaymentCreatorDialog
      instance.createBillPayment({ step: 'step1', title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees') })
      instance.$on('reloadData', this.reloadData)
      instance.$on('cancel', this.cancelBillPaymentCreatorDialog)
    },
    // 打印按钮触发事件
    toPrint(command) {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      const params = {}
      const multiplePrint = chooseRows.length > 1 && command === this.$t('Clearing.PrintByPaymentRequestNumber') // 是否按照多个打印
      if (chooseRows.length === 1 || params.multiplePrint) {
        params.BILLPAYMENT_UUID = chooseRows[0].uuid
        params.BILL_PAYMENT_UUID = chooseRows[0].uuid
        if (multiplePrint) {
          params.multiplePrint = true
          params.multipleBillPaymentUuid = keys
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILL_PAYMENT_UUID_LIST = keys
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.visible = true
      }
    },
    // 提交按钮触发事件
    doCommit() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
          keys.push({ uuid: billPayment.uuid, version: billPayment.version })
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          state: this.isDirectPayment ? 2 : 1,
          operation: 'commit',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 删除按钮触发事件
    doDelete() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATD'))
        return
      }
      const list = []
      for (const billPayment of chooseRows) {
        if (this.hasBusinessVerify && billPayment.state <= 2 && billPayment.realClearingState === 0) { list.push(billPayment) } else if (!this.hasBusinessVerify && billPayment.state <= 1 && billPayment.realClearingState === 0) { list.push(billPayment) }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('Message.BillPaymentDeleteTips'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_STDTPA'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const mapBillPayment = []
        for (const billPayment of list) {
          if (billPayment.uuid && billPayment.version) {
            const map = {
              uuid: billPayment.uuid,
              version: billPayment.version
            }
            if (mapBillPayment.indexOf(map) < 0) {
              mapBillPayment.push(map)
            }
          }
        }
        this.loading = getLoading()
        batchDelBillPayment(mapBillPayment, this.location).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 业务审核按钮触发事件
    doBusinessApproval() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if ((this.isDepartmentPermit && billPayment.state === 6) || (!this.isDepartmentPermit && billPayment.state === 1)) {
          if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          state: 2,
          operation: 'businessApproval',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 部门审批按钮触发事件
    doDepartmentApproval() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (this.isDepartmentPermit && billPayment.state === 1) {
          if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          state: 6,
          operation: 'departmentApproval',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 财务审批按钮触发事件
    doFinancialApproval() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATR'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
          keys.push({ uuid: billPayment.uuid, version: billPayment.version })
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          state: 3,
          operation: 'financialApproval',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 退回按钮触发事件
    doBack() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATR'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        let map = null
        if (billPayment.state === 3) {
          map = { uuid: billPayment.uuid, version: billPayment.version, state: 2 }
        } else if (billPayment.state === 2) {
          map = { uuid: billPayment.uuid, version: billPayment.version, state: 1 }
        } else if (billPayment.state === 1 || billPayment.state === 6) {
          map = { uuid: billPayment.uuid, version: billPayment.version, state: 0 }
        }
        if (map && keys.indexOf(map) < 0) {
          keys.push(map)
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          operation: 'return',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 财务审核按钮触发事件
    doFinancialAudit() {
      if (!this.isPaymentApplyFinancialAudit) {
        this.$message.warning(this.$t('Clearing.CantDirectlyChangeConfigurationAgain'))
        return
      }
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATR'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
          keys.push({ uuid: billPayment.uuid, version: billPayment.version })
        }
      }
      if (keys.length > 0) {
        const params = {
          billPayments: keys,
          state: 3,
          operation: 'financialAudit',
          approveHistoryJc: true
        }
        this.loading = getLoading()
        updateBillPaymentState(params).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 发送云平台
    commitBillPayment() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
        this.canSendWeaver = false
        return
      } else {
        const toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH'
        if (toExoSystemYGSH) {
          const list = []
          for (const data of chooseRows) {
            if (data.uuid) {
              list.push(data.uuid)
            }
          }
          sendLtsBillPaymentFunc(list).then(res => {
            if (res.data === 'ok') {
              this.$message.success(this.$t('Message.SynchronizationSucceeded'))
              this.$refs.queryBillPayment.toQueryBillPaymentList()
            } else if (res.data === 'not data') {
              this.$message.warning(this.$t('Message.NoSynchronizationContent'))
            } else {
              this.$message.warning(res.data)
            }
          })
        } else {
          let billPaymentNos = ''
          for (let i = 0; i < chooseRows.length - 1; i++) {
            billPaymentNos = billPaymentNos + chooseRows[i].billPaymentNo + ','
          }
          billPaymentNos = billPaymentNos + chooseRows[chooseRows.length - 1].billPaymentNo
          const params = {
            paymentNo: billPaymentNos,
            branchId: this.$store.getters.currentOfficeId
          }

          SendWeaverJinchang(params).then(res => {
            if (res.data === 0) {
              this.$message.warning(this.$t('CargoMsg.Cargo_OperationFailed'))
            } else {
              this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
              this.$refs.queryBillPayment.toQueryBillPaymentList()
            }
          }).finally(() => {
            this.loading.close()
          })
        }
      }
      // const billPayment = {
      //   state: state,
      //   inputDate: chooseRows[0].inputDate,
      //   currency: chooseRows[0].currency,
      //   billPayments: []
      // }
      // for (let i = 0; i < chooseRows.length; i++) {
      //   const selectItem = {}
      //   selectItem.uuid = chooseRows[i].uuid
      //   selectItem.version = chooseRows[i].version
      //   billPayment.billPayments.push(selectItem)
      // }
      // this.loading = getLoading()
      // SendWeaver(billPayment).then(res => {
      //   if (res.data === 0) {
      //     this.$message.warning(this.$t('CargoMsg.Cargo_OperationFailed'))
      //     this.canSendWeaver = false
      //   } else {
      //     this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      //     this.$refs.queryBillPayment.toQueryBillPaymentList()
      //     this.canSendWeaver = false
      //   }
      // }).finally(() => {
      //   this.loading.close()
      //   this.canSendWeaver = false
      // })
    },
    // 重新加载列表数据
    reloadData() {
      this.$refs.queryBillPayment.toQueryBillPaymentList()
    }, // 重新加载列表数据
    cancelBillPaymentCreatorDialog() {
      this.billPaymentCreatorDialog = null
    },
    // 保存成功回调函数
    saveBillPaymentSuccess(billPayments = []) {
      this.$refs.queryBillPayment.refreshRowData(billPayments)
    },
    // 列表双击事件
    rowDoubleClicked(billPayment = null) {
      this.toDetail(true, billPayment)
    }
  }
}
</script>

<style lang="scss">
.tab-bill-payment {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 13px !important;
    }
    .el-form-item__content {
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
